/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import {
  useSurveyDetail,
} from "./QuestionFlow/QuestionContext";
import SurveyQuestion from "./SurveyQuestion";
import { SurveyDetailOnboarding } from "./SurveyDetailOnboarding";
import Loading from "components/loading";
import Error from "components/error";
import { useParams } from "react-router-dom";
import ThankYouPage from "components/thankyou/thankyou-page";

function SurveyDetail({ setHeaderTitle = () => {} }: { setHeaderTitle?: any }) {
  const { survey, begin, status, loading, initSurvey,error } = useSurveyDetail();
  const {surveyId} = useParams();
  
  useEffect(() => {
    initSurvey(surveyId)
  }, [surveyId])

  useEffect(() => {
    if (survey && survey.name) {
      setHeaderTitle(survey.name);
    }
  }, [survey, setHeaderTitle]);

  if (!survey && !loading && error) return <Error />;
  if(loading) return <Loading />
  if (status === "idle")
    return <SurveyDetailOnboarding survey={survey} begin={begin} />;
  if (status === "questions") return <SurveyQuestion name={survey.name}/>;
  if (status === "completed") return <ThankYouPage titleProp={'Umfrage abgeschlossen.'} textProp={'Vielen Dank für Deine Teilnahme.'}/>
}

const Survey = ({ setHeaderTitle }) => {
  return (
      <SurveyDetail setHeaderTitle={setHeaderTitle} />
  );
};

export default Survey;
